import {FormikConfig} from "@/types/formik-config";
import {useFormik} from "formik";
import {useEffect} from "react";
import {apiConfig, useStore} from "@/store";
import {IRole} from "@/types/auth-data";
import {setSession} from "@/api/auth";
import {FormActive} from "@/types/login-form-active";

export const useObserveFormActive = () => {
    const formActive = useStore().formActiveStore.formActive;
    const session = apiConfig.session;
    useEffect(() => {
        if (formActive in [FormActive.Login, FormActive.RegData, FormActive.Email]) {
            if (session.role !== IRole.Anon ) {
                session.setItemSession(null)
                setSession().finally();
            }
        }
    }, [formActive])
}
export const useSubmitting = <T>(formik: FormikConfig<T>) => {
    useEffect(() => {
        if (formik.isSubmitting) {
            const timer = setTimeout(() => {
                formik.setSubmitting?.(false);
            }, 4500)
            return () => clearTimeout(timer)
        }
    }, [formik.isSubmitting])
}

export const useEnterKeydown = (isFocus: boolean, onSubmit: ()=>void, setIsFocus: (isFocus: boolean)=>void) => {
    useEffect(() => {
        const listener = (event: KeyboardEvent) => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                if (isFocus) {
                    onSubmit()
                    setIsFocus(false)
                }
            }
        };
        document.addEventListener("keydown", listener);
        return () => {
            document.removeEventListener("keydown", listener);
        };
    }, [])
}

export const useFormikConfig = <T>(initialValues: any, onSubmit: ()=>void, validationSchema: any): FormikConfig<T> => useFormik({
    initialValues: initialValues,
    onSubmit: onSubmit,
    validateOnBlur: true,
    validateOnMount: true,
    validationSchema: validationSchema,
})